import { Typography } from '@mui/material';
import React from 'react';
import Content from '../components/Layout/Content';

export const ExportRecords = () => {
  return (
    <Content>
      <Typography>In the Export Records Page!</Typography>
    </Content>
  );
};
